const routes = {
	path: '/',
	component: resolve => require ( ['./../customer-views/index.vue'], resolve ),
	children: [
		{
			path: '',
			alias: 'home',
			component: resolve => require ( ['./../customer-views/home.vue'], resolve )
		},
		{
			path: 'signup',
			alias: 'signin',
			component: resolve => require ( ['./../customer-views/register-pages/register.vue'], resolve )
		},

		///// cua liệu
		{
			path: 'verifyotp1',
			alias: 'verifyotp',
			component: resolve => require ( ['./../customer-views/register-pages/verifyotp.vue'], resolve )
		},


		////

		{
			path: 'moving-inout-services',
			
			component: resolve => require ( ['./../customer-views/moving-inout-services.vue'], resolve )
		},
		
		{
			path: 'spring-cleaning-services',
			
			component: resolve => require ( ['./../customer-views/spring-cleaning-services.vue'], resolve )
		},

		{
			path: 'select-service',
			component: resolve => require ( ['./../customer-views/select-service.vue'], resolve )
		},
		{
			path: 'services',
			component: resolve => require ( ['./../customer-views/our-services.vue'], resolve )
		},
		{
			path: 'contact-us',
			component: resolve => require ( ['./../customer-views/contact.vue'], resolve )
		},
		{
			path: 'join-us',
			component: resolve => require ( ['./../customer-views/join-as-helper-form.vue'], resolve )
		},
		{
			path: 'regular-purchase-credit-package',
			component: resolve => require ( ['./../customer-views/regular-purchase-credit-package.vue'], resolve )
		},
		{
			path: 'regular/new',
			alias: 'regular',
			component: resolve => require ( ['./../customer-views/forms/regular/index.vue'], resolve )
		},
		{
			path: 'regular/new/:preselectedPackage',
			component: resolve => require ( ['./../customer-views/forms/regular/index.vue'], resolve )
		},
		{
			path: 'book-spring-cleaning/new',
			alias: 'spring-cleaning',
			component: resolve => require ( ['./../customer-views/forms/spring-cleaning/index.vue'], resolve )
		},
		{
			path: 'bookmovingin-outcleaning/new',
			alias: 'moving-in-out',
			component: resolve => require ( ['./../customer-views/forms/moving-in-out/index.vue'], resolve )
		},
		{
			path: 'one-time/new',
			alias: 'one-time',
			component: resolve => require ( ['./../customer-views/forms/one-time/index.vue'], resolve )
		},
		{
			path: 'terms-and-conditions',
			component: resolve => require ( ['./../customer-views/terms-and-conditions.vue'], resolve )
		},
		{
			path: 'submission-successful',
			component: resolve => require ( ['./../customer-views/submission-successful.vue'], resolve )
		},
		{
			path: 'contact-successful',
			component: resolve => require ( ['./../customer-views/contact-submitted.vue'], resolve )
		},
		{
			path: 'one-time/success',
			alias: 'booking-success',
			component: resolve => require ( ['./../customer-views/forms/booking-success.vue'], resolve )
		},
		{
			path: 'regular/success',
			alias: 'booking-success',
			component: resolve => require ( ['./../customer-views/forms/booking-success.vue'], resolve )
		},
		{
			path: 'book-spring-cleaning/success',
			alias: 'booking-success',
			component: resolve => require ( ['./../customer-views/forms/booking-success.vue'], resolve )
		},
		{
			path: 'bookmovingin-outcleaning/success',
			alias: 'booking-success',
			component: resolve => require ( ['./../customer-views/forms/booking-success.vue'], resolve )
		},
	]
};

export default routes;


// WEBPACK FOOTER //
// ./src/custom/routes/public-routes.js